import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '3.7793 15.7899'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M5.26371 25.4799C5.26371 23.9399 6.40371 0.599854 6.40371 0.599854H1.15371C1.15371 0.599854 2.29371 23.9399 2.29371 25.4799C2.29371 27.0199 -0.206287 27.8999 0.0137127 30.9799H7.54371C7.77371 27.8999 5.26371 27.0199 5.26371 25.4799Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="3.78201"
            y1="4.34455"
            x2="3.78201"
            y2="31.8709"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
